import * as requestFromServer from "./Curd";
import { NewAdscompanylistSlice, callTypes } from "./Slice";
import { NotificationManager } from "react-notifications";
import { uploadImage } from "./Curd";
const { actions } = NewAdscompanylistSlice;

export const createItem = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createItem(item)
    .then((response) => {
      const { item } = response.data;
      NotificationManager.success("success", "Data saved successfully!");
      dispatch(actions.itemCreated({ item }));
      return true;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const fetchSingle = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.singleItemFetched({ coinStoresForEdit: undefined })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getItemById(id)
    .then((response) => {
      const item = response;

      console.log("fjdjsbfjdfbdfbjfb", response);
      dispatch(actions.singleItemFetched({ coinStoresForEdit: item }));
      return response;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const uploadImageAction = (queryParams) => (dispatch) => {
  return uploadImage(queryParams.img)
    .then((response) => {
      const uploadimage = response.data;
      const imageField = queryParams.name;
      dispatch(actions.uploadImageSuccess({ uploadimage, imageField }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.uploadImageFailure(error));
    });
};

export const updateItem = (id, item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItem(id, item)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      dispatch(actions.itemUpdated({ id, item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};
export const resetStore = () => (dispatch) => {
  dispatch(actions.resetStore());
};

export const fetchCountriesList = (queryParams) => (dispatch) => {
  console.log("queryParams -> user -> com:", queryParams);
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCountriesList(queryParams)
    .then((response) => {
      console.log("response::All Country List", response);
      // const { totalCount, entities } = response.data;
      const countryList = response;
      console.log("countryList", countryList);
      dispatch(actions.CountryList({ countryList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCountriesDropdownList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCountriesDropdownList(queryParams)
    .then((response) => {
      console.log("response::All Country List", response);
      // const { totalCount, entities } = response.data;
      const countryDropdownList = response;
      console.log("countryDropdownList", countryDropdownList);
      dispatch(actions.CountryDropdownList({ countryDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchContestUsersList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getContestUsersList(queryParams)
    .then((response) => {
      console.log("response::fetchContestUsersList ", response);
      const contestUsers = response;
      console.log("usersssssssssss detailsss", contestUsers);
      dispatch(actions.contestUsersList({ contestUsers }));
      return response;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCompanyList = (queryParams) => (dispatch) => {
  // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getCompany(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.company({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCurrencyList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getCurrency(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.currency({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
